import { FlightEventHandler, registerEventHandlerClass } from './flight'
import { writable } from 'svelte/store'

export default class PrimaryLink extends FlightEventHandler {
	constructor(flight) {
		super(flight)

		const { subscribe, set, update } = writable({local: null, remote: null});
		this.subscribe = subscribe 
		this.set = set
		this.update = update
	}

	handleKeyframe(keyframe) {
		this.set({
			local: keyframe.primaryLink,
			remote: keyframe.remotePrimaryLink,
		})
	}

	handleFlightStep(message) {
		switch(message.type) {
			case "LINK_SWITCHED_LOCAL":
				this.update(old => {
					old.local = message.linkId
					return old
				})
				break
			case "LINK_SWITCHED_REMOTE":
				this.update(old => {
					old.remote = message.linkId
					return old
				})
				break
		}
	}
}

registerEventHandlerClass(PrimaryLink)